module.exports = __webpack_public_path__ + "static/media/scroll4_phone5.d8baf891.png";